import { useApi } from '~shared/providers/use-api';

import type { UseQueryOptions } from '@tanstack/react-query';
import { useMutation, useQuery } from '@tanstack/react-query';

import type { CreateOrderRequest, Order } from '..';
import { ORDERS_API_KEY } from '../api/orders-api';
import type { OrdersApi, FindOrdersRequestParams } from '../api/orders-api';

export function useCreateOrderMutation() {
  const ordersApi = useApi<OrdersApi>(ORDERS_API_KEY);

  return useMutation({
    mutationKey: ['create-order'],
    mutationFn: (order: CreateOrderRequest) => ordersApi.createOrder(order),
  });
}

export function useFindOrdersQuery(
  params: FindOrdersRequestParams,
  options: Omit<
    UseQueryOptions<unknown, Error, { orders: Order[]; total: number }>,
    'queryKey' | 'queryFn'
  >
) {
  const ordersApi = useApi<OrdersApi>(ORDERS_API_KEY);

  return useQuery({
    ...options,
    queryKey: ['find-orders', params],
    queryFn: async () => {
      const { items, pageInfo } = await ordersApi.getOrders(params);

      return {
        orders: items,
        total: pageInfo.total,
      };
    },
  });
}

export function useGetOrderByIdQuery(id: string) {
  const ordersApi = useApi<OrdersApi>(ORDERS_API_KEY);
  return useQuery({
    queryKey: ['get-order', id],
    queryFn: async () => ordersApi.getOrder(id),
  });
}
